var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetCallCountsByPeriodsMutation, useGetImportableModulesQuery, useGetKpiForCasesMutation, useGetRelationshipWOpportunitiesMutation, useSaveDashletPreferencesMutation, useSearchDashletChartMutation, } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { useParams } from "react-router-dom";
import { calculateRanges, limitOptionsByPeriod, periods, } from "@/components/forms/components/utils";
import KpiSettingsPanel from "./kpiSettingsPanel";
import { useKpiList as KPI } from "./widgetKPIAffaires";
export default function EditChartKPI(_a) {
    var _this = this;
    var _b, _c, _d, _e;
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, records = _a.records, id = _a.id, allDashlets = _a.allDashlets, _f = _a.kpiList, kpiList = _f === void 0 ? KPI : _f;
    var data = records === null || records === void 0 ? void 0 : records.rowMeta;
    var rowID = records === null || records === void 0 ? void 0 : records.rowId;
    var _g = useState(data), rowMeta = _g[0], setRowMeta = _g[1];
    var _h = useState("key"), key = _h[0], setKey = _h[1];
    var record = data === null || data === void 0 ? void 0 : data.find(function (item) { return item.id === id; });
    var _j = useState(""), titleChart = _j[0], setTitleChart = _j[1];
    var _k = useState(""), chartType = _k[0], setChartType = _k[1];
    var _l = useState(""), firstColor = _l[0], setFirstColor = _l[1];
    var _m = useState(), listMultiselect = _m[0], setListMultiSelect = _m[1];
    var _o = useState((_c = (_b = rowMeta === null || rowMeta === void 0 ? void 0 : rowMeta.find(function (item) { return item.id === id; })) === null || _b === void 0 ? void 0 : _b.refresh) !== null && _c !== void 0 ? _c : -1), refresh = _o[0], setRefresh = _o[1];
    var currentRowMeta = useMemo(function () { return rowMeta === null || rowMeta === void 0 ? void 0 : rowMeta.find(function (item) { return item.id === id; }); }, [rowMeta, id]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (currentRowMeta) {
            setRefresh(currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.refresh);
            setTitleChart(currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.title);
            setChartType(currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.type);
            setPeriod((_b = (_a = currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.chartData) === null || _a === void 0 ? void 0 : _a.period) !== null && _b !== void 0 ? _b : "semaine");
            setLimit((_d = (_c = currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.chartData) === null || _c === void 0 ? void 0 : _c.limit) !== null && _d !== void 0 ? _d : "La semaine dernière");
            !firstColor && setFirstColor(currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.firstColor);
            setKpiType(currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.kpiType);
            setListMultiSelect(currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.listMultiselect);
        }
    }, [currentRowMeta]);
    var t = useTranslation(["common", "Charts"]).t;
    var _p = useState(((_e = (_d = rowMeta === null || rowMeta === void 0 ? void 0 : rowMeta.find(function (item) { return item.id === id; })) === null || _d === void 0 ? void 0 : _d.searchedData) === null || _e === void 0 ? void 0 : _e.dateRange) || {}), recordsData = _p[0], setRecordsData = _p[1];
    var _q = useSaveDashletPreferencesMutation(), saveDashletPreferences = _q[0], _r = _q[1], dashletLoad = _r.isLoading, isError = _r.isError;
    var searchDashletChart = useSearchDashletChartMutation()[0];
    var _s = useGetRelationshipWOpportunitiesMutation(), getRelationshipWOpportunities = _s[0], response = _s[1].data;
    var _t = useGetCallCountsByPeriodsMutation(), getCallCountsByPeriods = _t[0], responseCalls = _t[1].data;
    var _u = useGetKpiForCasesMutation(), getKpiForCases = _u[0], _v = _u[1];
    var currentModule = useParams().module;
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var dateRanges, baseBody, fetchFunction, fetchParams, moduleToUse, response_1, newChartData_1, searchFields, updatedDashlets, updatedDashletsState, key_1, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    dateRanges = calculateRanges(period, limit) || [];
                    baseBody = {
                        periods: dateRanges,
                        firstColor: firstColor,
                    };
                    fetchFunction = void 0;
                    fetchParams = {};
                    moduleToUse = currentModule &&
                        ["Leads", "Opportunities", "Prospects"].includes(currentModule)
                        ? currentModule
                        : "";
                    switch (kpiType) {
                        case "callscount":
                            fetchFunction = getCallCountsByPeriods;
                            fetchParams = { module: moduleToUse, body: baseBody };
                            break;
                        case "leadscount":
                            fetchFunction = getCallCountsByPeriods;
                            fetchParams = { module: "Leads", body: baseBody };
                            break;
                        case "resolvedContact":
                            fetchFunction = getKpiForCases;
                            fetchParams = { module: currentModule || "", body: baseBody };
                            break;
                        case "averageResolutionTime":
                        case "averageResponseTime":
                        case "openedClosedTickets":
                        case "costPerResolution":
                        case "averageCustomerEffort":
                            fetchFunction = getKpiForCases;
                            fetchParams = {
                                module: currentModule || "",
                                body: __assign(__assign({}, baseBody), { kpiType: kpiType, unit: period }),
                            };
                            break;
                        case "escalationRate":
                        case "agentOccupationRate":
                            fetchFunction = getKpiForCases;
                            fetchParams = {
                                module: currentModule || "",
                                body: __assign(__assign({}, baseBody), { kpiType: kpiType, unit: period, list: listMultiselect }),
                            };
                            break;
                        default:
                            fetchFunction = getRelationshipWOpportunities;
                            fetchParams = __assign(__assign({}, (currentModule ? { module: currentModule } : {})), { body: __assign(__assign({}, baseBody), { cumulatif: cumulatif, kpiType: kpiType }) });
                            break;
                    }
                    return [4 /*yield*/, fetchFunction(fetchParams).unwrap()];
                case 1:
                    response_1 = _c.sent();
                    newChartData_1 = response_1 === null || response_1 === void 0 ? void 0 : response_1.data;
                    setKey(Date.now());
                    if (!newChartData_1) {
                        onClose();
                        return [2 /*return*/];
                    }
                    searchFields = ((_b = (_a = rowMeta.find(function (item) { return item.id === id; })) === null || _a === void 0 ? void 0 : _a.chartData) === null || _b === void 0 ? void 0 : _b.searchFields) ||
                        {};
                    updatedDashlets = rowMeta.map(function (dashlet) {
                        return dashlet.id === id
                            ? __assign(__assign({}, dashlet), { chartData: __assign(__assign({}, newChartData_1), { module: module || "", period: period, limit: limit }), type: chartType, title: titleChart, kpiType: kpiType, refresh: refresh, firstColor: firstColor, listMultiselect: listMultiselect }) : dashlet;
                    });
                    updatedDashletsState = __assign({}, allDashlets);
                    for (key_1 in updatedDashletsState) {
                        if (updatedDashletsState[key_1].id === rowID) {
                            updatedDashletsState[key_1] = __assign(__assign({}, updatedDashletsState[key_1]), { meta: updatedDashlets });
                            break;
                        }
                    }
                    return [4 /*yield*/, saveDashletPreferences({
                            dashlets: updatedDashletsState,
                            isNew: false,
                        }).unwrap()];
                case 2:
                    _c.sent();
                    onClose();
                    return [2 /*return*/, updatedDashletsState];
                case 3:
                    error_1 = _c.sent();
                    console.error("Failed to fetch or save chart data:", error_1);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var _w = useGetImportableModulesQuery(null), menuResponse = _w.data, isLoading = _w.isLoading;
    var module = useParams().module;
    var _x = useState("non"), cumulatif = _x[0], setCumulatif = _x[1];
    var _y = useState("semaine"), period = _y[0], setPeriod = _y[1];
    var _z = useState("Le mois dernier"), limit = _z[0], setLimit = _z[1];
    var availableLimits = useMemo(function () {
        return limitOptionsByPeriod[period] || [];
    }, [period]);
    var handleChangeCumulatif = function (event) {
        setCumulatif(event.target.value);
    };
    var _0 = useState(""), kpiType = _0[0], setKpiType = _0[1];
    var optionsGraph = kpiType !== "pipeline"
        ? [
            { value: "texte", label: t("app.LBL_TEXT_CHART") },
            { value: "horizontalBar", label: t("app.LBL_HORIZONTALBAR_CHART") },
            { value: "bar", label: t("app.LBL_BAR_CHART") },
            { value: "line", label: t("app.LBL_LINE_CHART") },
        ]
        : [
            { value: "texte", label: t("app.LBL_TEXT_CHART") },
            { value: "funnelGraph", label: t("app.LBL_FUNNEL_CHART") },
        ];
    return (_jsx("div", __assign({ className: "fixed inset-0 flex items-center justify-center bg-gray-950 bg-opacity-50 z-50 " }, { children: _jsxs("div", __assign({ className: " bg-[var(--colors-background-popup-sec)] p-5 rounded-lg shadow-lg relative w-1/3 " }, { children: [dashletLoad && _jsx(LoaderImage, {}), _jsxs("div", __assign({ className: "flex justify-between items-center border-b pb-2" }, { children: [_jsx("h2", __assign({ className: "text-lg font-semibold" }, { children: titleChart })), _jsx("button", __assign({ onClick: onClose, className: "text-gray-500 hover:text-red-500" }, { children: _jsx(FontAwesomeIcon, { icon: faClose }) }))] })), _jsx(KpiSettingsPanel, { titleChart: titleChart, kpiType: kpiType, setKpiType: setKpiType, kpiList: kpiList, setTitleChart: setTitleChart, module: module, chartType: chartType, setChartType: setChartType, optionsGraph: optionsGraph, period: period, setPeriod: setPeriod, periods: periods, limit: limit, setLimit: setLimit, availableLimits: availableLimits, cumulatif: cumulatif, handleChangeCumulatif: handleChangeCumulatif, firstColor: firstColor || (currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.firstColor), setFirstColor: setFirstColor, listMultiselect: listMultiselect, setListMultiSelect: setListMultiSelect }), _jsxs("div", __assign({ className: "flex justify-end space-x-2 border-t pt-2" }, { children: [_jsx("button", __assign({ onClick: handleSave, className: "bg-[var(--colors-button-success)] text-sm text-[var(--colors-label)] px-4 py-2 rounded-md hover:bg-[var(--colors-button-success--hover)]" }, { children: t("app.LBL_SAVE_BUTTON_LABEL", { ns: "common" }) })), _jsx("button", __assign({ onClick: onClose, className: "text-[var(--colors-label)] text-sm bg-[var(--colors-button-info)] px-4 py-2 rounded-md hover:bg-[var(--colors-button-info--hover)]" }, { children: t("app.LBL_CLEAR_BUTTON_LABEL") }))] }))] })) }), key));
}
